import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, type OnDestroy, type OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { FaqComponent } from '../../../features/faq/faq.component';
import { ConfigResourceService } from '../../../services/config-resource.service';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-faq-modal',
  templateUrl: './faq-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ModalComponent, FaqComponent]
})
export class FaqModalComponent implements OnInit, OnDestroy {
  headerText: string = '';
  closeText: string = '';
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly dialogRef: MatDialogRef<FaqComponent>,
    private readonly configService: ConfigResourceService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.configService.configLoaded$.subscribe({
        next: loaded => {
          if (loaded) {
            this.headerText = this.configService.getProcessedResourceValue<string>('Spa_Site_FAQ', 'Frequently Asked Questions');
            this.closeText = this.configService.getProcessedResourceValue<string>('DC5_Close_Text', 'Close');
            this.cdr.markForCheck();
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
